export const DEFAULT_CAMERA_OPTIONS = [80, 2, 0.1, 20000]
